import { useEffect } from "react";
import type { PendingAuthTelemetry } from "~/tooling/session/consume-pending-auth-telemetry";
import { fireAuthTelemetryEvents } from "~/tooling/telemetry/fire-auth-telemetry-events";

export function useAuthTelemetryEvent(
	pendingAuthTelemetry?: PendingAuthTelemetry | null,
	authTelemetryId?: string | null,
): void {
	useEffect(() => {
		fireAuthTelemetryEvents(pendingAuthTelemetry, authTelemetryId);
	}, [pendingAuthTelemetry, authTelemetryId]);
}
